import { Flex, Grid } from "@payping/web-components";
import { FC, PropsWithChildren } from "react";
import BnplActivationPageFormLayoutSteps from "./Steps";

const BnplActivationPageFormLayout: FC<PropsWithChildren> = ({ children }) => {
  const { lg } = Grid.useBreakpoint();
  return (
    <Flex className="tw-min-h-full tw-w-full" vertical={!lg}>
      <BnplActivationPageFormLayoutSteps />
      {children}
    </Flex>
  );
};

export default BnplActivationPageFormLayout;
